import { Component, EventEmitter, Output, ChangeDetectorRef, ViewChild, OnDestroy } from '@angular/core';
import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { Subscription } from 'rxjs';
import { CustomerService } from '../../../../services/customer.service';

@Component({
  selector: 'app-enterprises-search',
  templateUrl: './enterprises-search.component.html',
  styleUrls: ['./enterprises-search.component.scss']
})
export class EnterprisesSearchComponent implements OnDestroy {
  searchValue = '';
  private lastSearchTerm = '';

  // datasource = array semplice
  results: any[] = [];
  selected: any | null = null;
  loading = false;
  searchEpoch = 0;   // contatore di “sessione” delle ricerche
  isClosing  = false; // true durante cancel/confirm per bloccare reload


  displayedColumns: string[] = ['denominazione', 'siren', 'siret', 'indirizzo'];

  // stato paginator lato server
  length = 0;        // preso da results[0].totalResponse
  pageIndex = 0;     // 0-based
  pageSize = 10;     // limit
  pageSizeOptions = [5, 10, 25, 100];

  private paginatorSub?: Subscription;

  @Output() enterpriseSelected = new EventEmitter<any>();

  // aggancio sicuro anche con *ngIf
  private _paginator!: MatPaginator;
  @ViewChild('documentPaginator', { static: false })
  set documentPaginator(p: MatPaginator) {
    this._paginator = p;
    if (p) {
      this.bindPaginator();
      this.syncPaginatorUI();
    }
  }

  constructor(private customerService: CustomerService, private cdr: ChangeDetectorRef) {}

  ngOnDestroy(): void {
    this.paginatorSub?.unsubscribe();
  }

  // --- paginator wiring ---
  private bindPaginator(): void {
    // stato iniziale
    this._paginator.pageIndex = this.pageIndex;
    this._paginator.pageSize = this.pageSize;
    this._paginator.length = this.length;

    this.paginatorSub?.unsubscribe();
    this.paginatorSub = this._paginator.page.subscribe(({ pageIndex, pageSize }) => {
      this.pageIndex = pageIndex;
      this.pageSize = pageSize;
      this.loadPage(); // ricarica offset/limit
    });
  }

  private syncPaginatorUI(): void {
    if (!this._paginator) return;
    this._paginator.length = this.length;
    this._paginator.pageIndex = this.pageIndex;
    this._paginator.pageSize = this.pageSize;
  }

  // --- ricerca ---
  async findfromInsee(termRaw: string): Promise<void> {
    const term = (termRaw || '').trim();
    if (!term) return;

    this.lastSearchTerm = term;
    this.pageIndex = 0;

    if (this._paginator) this._paginator.firstPage();

    await this.loadPage();
  }

  /**
   * Carica la pagina corrente dalla WebAPI.
   * offset = pageIndex * pageSize
   * limit  = pageSize
   */
  private async loadPage(): Promise<void> {
    if (!this.lastSearchTerm || this.isClosing) return;

    const myEpoch = ++this.searchEpoch;     // “numero” della richiesta corrente
    const offset = this.pageIndex * this.pageSize;
    const limit  = this.pageSize;

    try {
      this.loading = true;

      const arr = await this.customerService.InseefindByTextPaged(
        this.lastSearchTerm, offset, limit
      );

      // Se nel frattempo è avvenuto un confirm/cancel o è partita un’altra ricerca, ignora
      if (this.isClosing || myEpoch !== this.searchEpoch) return;

      this.results = Array.isArray(arr) ? arr : [];
      const totalFromItem = this.results[0]?.totalResponse;
      this.length = Number.isFinite(+totalFromItem) ? +totalFromItem : (this.results.length || 0);

      // se eri selezionato, riaggancia per siret
      if (this.selected) {
        const again = this.results.find(r => r.siret === this.selected!.siret);
        if (again) this.selected = again;
      }

      // se usi MatTableDataSource:
      // this.dataSource.data = this.results;
      // altrimenti [dataSource]="results" direttamente in HTML

      this.syncPaginatorUI?.(); // se hai la funzione; altrimenti aggiorna paginator
      this.cdr.markForCheck?.();
    } catch (e) {
      if (this.isClosing || myEpoch !== this.searchEpoch) return;
      this.results = [];
      this.length = 0;
    } finally {
      if (myEpoch === this.searchEpoch) this.loading = false;
    }
}


  // --- selezione / azioni ---
  selectItem(item: any): void { this.selected = item; }
  isSelected(item: any): boolean { return !!this.selected && this.selected.siret === item.siret; }

  cancelSelection(): void {
  this.isClosing = true;
  this.searchEpoch++;           // invalida qualsiasi loadPage ancora in volo
  this.searchValue = '';
  this.selected = null;
  this.results = [];
  this.length = 0;
  this.pageIndex = 0;

  // se usi MatTableDataSource:
  // this.dataSource.data = [];

  if (this._paginator) {
    this._paginator.firstPage();
    this._paginator.length = 0;
  }
  this.cdr.detectChanges?.();

  // sblocca dopo un tick (evita riaperture immediate da eventi UI)
  queueMicrotask(() => { this.isClosing = false; });
}

  confirmSelection(): void {
    if (!this.selected) return;
    this.enterpriseSelected.emit(this.selected);
    this.cancelSelection();
  }
}
